import { useEffect, useState } from "react";
import { useAuth, useZudoku } from "zudoku/hooks";
import { Skeleton } from "zudoku/ui/Skeleton";

const className =
  "flex items-center gap-2 px-3 py-1 rounded-full bg-muted/50 border border-border transition-all no-underline";

export function BalanceDisplay() {
  const { isAuthenticated, isPending } = useAuth();
  const { getApiIdentities } = useZudoku();
  const [balance, setBalance] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!isAuthenticated) return;

    const fetchBalance = async () => {
      try {
        const identities = await getApiIdentities();
        if (!identities[0]) return;

        const request = new Request("https://api.to.design/balance");
        const authedRequest = await identities[0].authorizeRequest(request);
        const response = await fetch(authedRequest);
        if (response.ok) {
          const data = await response.json();
          setBalance(data.remaining ?? 0);
        }
      } catch (err) {
        console.error("Error fetching balance:", err);
      }
    };

    fetchBalance();
    const interval = setInterval(fetchBalance, 60000);
    return () => clearInterval(interval);
  }, [isAuthenticated]);

  if (!isAuthenticated || isPending) return null;

  return balance === undefined ? (
    <div className={className}>
      <Skeleton className="h-4 w-8" />
      credits
    </div>
  ) : (
    <a
      href="/pricing"
      className={`${className} hover:bg-muted hover:border-foreground/20`}
      title="Click to purchase more credits"
    >
      <span className="text-sm font-semibold">{balance.toLocaleString()}</span>
      credits
    </a>
  );
}
